import initProteusReplacement from 'lib/proteus-replacement.js';

/**
 * Viva Design System Entry
 * Imports the new utility-first CSS framework
 */
import '#styles/viva.css'

document.addEventListener('DOMContentLoaded', () => {
  initProteusReplacement();
})
